import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import router from './router';
import store from './store';
import App from './App.vue';
import './vee-validate.js';
import axios from 'axios';

import './assets/custom.scss';

import './assets/main.css';

axios.defaults.timeout= 20000;
axios.interceptors.response.use(undefined, function(error) {
  if (error.response.status === 401) {
    router.replace('/login');
  }

  return Promise.reject(error);
});

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

axios.get('/api/account/details')
.then(res => {
  if (res.data !== '') {
    store.commit('login', res.data);
  }
  
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
});


